// extracted by mini-css-extract-plugin
module.exports = {"root":"PrevCard_root__1rFrT","media":"PrevCard_media__2JT7k"};